export default __webpack_public_path__ + "static/media/ico-policy.0bc91e9b.svg";